@if (loadingService.isLoading()) {
   <div
      class="d-flex flex-column jc-center ai-center pos-absolute"
      [class.bc-loader]="hasBackgound()"
      [class.wh-loader]="!hasBackgound()"
   >
      <div class="loader"></div>

      @if (loadingService.loadingMessage(); as message) {
         <div class="text-center f-s-14 text-color-white m-t-20">{{ message | i18n }}</div>
      } @else if (textLabel()) {
         <div class="text-center f-s-14 text-color-white m-t-20">{{ textLabel()! | i18n }}</div>
      }
   </div>
}
